type ProblemBody = {
  type?: unknown;
  title?: unknown;
  detail?: unknown;
  status?: unknown;
  correlation_id?: unknown;
};

type ErrorWithContext = {
  message?: string;
  context?: {
    clone?: () => { json: () => Promise<unknown> };
    json?: () => Promise<unknown>;
  };
};

export function problemErrorCode(body: unknown): string | null {
  if (!body || typeof body !== 'object') return null;
  const problem = body as ProblemBody;
  if (typeof problem.type === 'string' && problem.type.trim()) {
    const slug = problem.type.replace(/\/+$/, '').split('/').pop();
    if (slug && slug !== 'errors') return slug;
  }
  if (typeof problem.title === 'string' && problem.title.trim()) return problem.title;
  if (typeof problem.status === 'number') return String(problem.status);
  return null;
}

async function readProblemBody(err: unknown): Promise<unknown | null> {
  const context = (err as ErrorWithContext | null)?.context;
  if (context && typeof context.clone === 'function') {
    try {
      return await context.clone().json();
    } catch {
      // Response body was not JSON or already consumed.
    }
  } else if (context && typeof context.json === 'function') {
    try {
      return await context.json();
    } catch {
      // Response body was not JSON or already consumed.
    }
  }
  return null;
}

export async function functionsErrorMessage(err: unknown, fallback: string): Promise<string> {
  const body = await readProblemBody(err);
  if (body && typeof body === 'object') {
    console.error('[edge-function]', body);
    const code = problemErrorCode(body);
    if (code) return `${fallback} (${code})`;
  }
  const raw = (err as Error)?.message;
  if (raw && !/non-2xx/i.test(raw)) return raw;
  return fallback;
}
